import React, {useState} from "react";
import axios from "axios";


const apiBaseUrl = "https://careergpt.herokuapp.com";
// const apiBaseUrl = "http://localhost:5000";
const Header = ({ accessToken, onInputChange }) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState('');
  
  const handleGetCode = async (e) =>{
    e.preventDefault();
    if(validateEmail(email)){
      try {
        console.log(process.env)
        const response = await axios.post(`${apiBaseUrl}/api/add_token`, {
          email: email 
        });
        alert(`Please check ${email} for access code. If you dont see it in your inbox, check spam also.`)
      } catch(error){
        console.log(error)
        if(error.response.status == 400){
          alert(`Error: ${error.response.data}`)
        }else{
          alert("Error: try again or contact our support team for assistance.")
      }
      }
    }
   
  }
  const validateEmail = (input) => {
    // A simple regex for email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (emailRegex.test(input)) {
      setEmailError('');
      return true;
    } else {
      setEmailError('Invalid email format');
      return false;
    }
  };
  return (<div class="navbar bg-neutral text-neutral-content">
    <div className="flex-1"><a class="btn btn-ghost normal-case text-xl">Career GPT</a></div>
    <div className="flex-none">
      <div className="dropdown dropdown-end mx-1.5">
        <input tabIndex={0}
          type="text"
          value={accessToken}
          onChange={(e) => onInputChange(e.target.value)}
          className="bg-white text-black p-2 rounded border"
          placeholder="Enter Access Code Here ..."
        />
        {/* <label tabIndex={0} className="btn btn-ghost">
        <span>&#8594; Access Code</span> 
      </label> */}
        <div tabIndex={0} className="mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow">
          <div className="card-body">

            <div className="card-actions text-left">
            <span className="text-neutral">Access token is used to grant permission to services</span>
            <button className="text-primary">Don't have access code?</button>
              <form action={`${apiBaseUrl}/api/checkout-session`} method="POST">
                
                <button className="btn btn-primary btn-block" type="submit">Purchase Token</button>
              </form>
            </div>
          </div>
        </div>

      </div>
      <div className="dropdown dropdown-end">
      <label tabIndex={1} className="btn btn-sm gap-2 btn-success">
        <span> Free Access Code</span> 
        {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg> */}
      </label>
        
        {/* <label tabIndex={0} className="btn btn-ghost">
        <span>&#8594; Access Code</span> 
      </label> */}
        <div tabIndex={1} className="mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow">
          <div className="card-body">
          
            <span className="text-neutral">We offer free code for first time access. Enter email below</span>
            <div className="card-actions text-left">
              <form onSubmit={handleGetCode}>
                  <input
                  type="text"
                  className="bg-white text-black p-2 rounded border"
                  onChange={(e)=>setEmail(e.target.value)}
                  placeholder="Email ..."
                />
                {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
              <button className="btn btn-primary btn-block mt-2" type="submit">Get Code</button>
              </form>
              
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>);
}

export default Header;